module.exports = __webpack_public_path__ + "img/Ai.571d1e1a.png";